export const kConverter = val => {
  return (val / 1000).toFixed(1).replace(/\.0$/, '') + ' K';
};
